module.exports = __webpack_public_path__ + "img/dandonggonggongziyuan.181d7e01.png";